import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Accommodation, AccommodationCreate, AccommodationPublicProfile, IAccommodationSearchResult, AccommodationPhotoUpload, AccommodationImageType } from 'models';

@Injectable({
	providedIn: 'root',
})
export class AccommodationService {
	constructor(private http: HttpClient) {}

	public getAll(): Observable<Accommodation[]> {
		return this.http.get<Accommodation[]>('api/accommodation/getall');
	}

	public get(accommodationId: number): Observable<Accommodation> {
		return this.http.get<Accommodation>(`api/accommodation/get/${accommodationId}`);
	}

	public getByOneStep(oneStepIdentifier: string): Observable<Accommodation[]> {
		return this.http.get<Accommodation[]>(`api/accommodation/getbyonestep/${oneStepIdentifier}`);
	}

	public create(accommodation: AccommodationCreate): Observable<AccommodationCreate> {
		return this.http.post<AccommodationCreate>('api/accommodation/create', accommodation);
	}

	public edit(accommodation: Accommodation): Observable<Accommodation> {
		return this.http.put<Accommodation>('api/accommodation/edit', accommodation);
	}

	public searchByPostcodeAndCheckin(searchString: string, checkIn: Date, lastName: string): Observable<IAccommodationSearchResult[]> {
		return this.http.get<IAccommodationSearchResult[]>(`api/accommodation/searchbypostcodeandcheckin/${searchString}/${checkIn}/${lastName}`);
	}

	public searchByHostCode(hostCode: string, postcode): Observable<IAccommodationSearchResult[]> {
		return this.http.get<IAccommodationSearchResult[]>(`api/accommodation/searchbyhostcode/${hostCode}/${postcode}`);
	}

	uploadAccommodationPhotos(accommodationPhoto: AccommodationPhotoUpload, files: File[]): Observable<void> {
		const formData = new FormData();

		for (const file of files) {
			formData.append('file', file, file.name);
		}

		formData.append('accommodationPhotoUpload', JSON.stringify(accommodationPhoto));

		// change the default content type which is json to allow file upload
		return this.http.post<any>('api/accommodation/uploadaccommodationphotos', formData);
	}

	getAccommodationPhotos(bookingImageType: AccommodationImageType, accommodationId: number): Observable<string[]> {
		return this.http.get<string[]>(`api/accommodation/getaccommodationphotos/${bookingImageType}/${accommodationId}`);
	}

	public getPublicProfile(accommodationId: number): Observable<AccommodationPublicProfile> {
		return this.http.get<AccommodationPublicProfile>(`api/accommodation/getpublicprofile/${accommodationId}`);
	}

	public activeToggle(accommodationId: number): Observable<void> {
		return this.http.post<void>('api/accommodation/activetoggle', accommodationId);
	}

	public deactivateAll(): Observable<void> {
		return this.http.get<void>('api/accommodation/deactivateall');
	}
}
